import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { isAxiosError } from "axios";
import { eventsQueryKeys, postersQueryKeys } from "../query-keys";
import { FileSchemaType, PosterGenerationForm } from "../schemas";

const generatePoster = async (body: PosterGenerationForm) => {
  try {
    const { data } = await privateAxios.post<{ image: FileSchemaType }>(
      "/posters/generate",
      body
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.response?.data.message || error.message);
    }
    throw error;
  }
};

export const useGeneratePosterMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: generatePoster,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: postersQueryKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.getComplete(variables.eventId),
      });
    },
  });
};
